import { createFeatureSelector } from "@ngrx/store";
import {
    RemindersState,
} from "./model";

export const REMINDERS_FEATURE_KEY = "vadmin.health.reminders";

export const getSmartFormsState = createFeatureSelector<RemindersState>(REMINDERS_FEATURE_KEY);
